import { getRequest, URL } from "shared/utils";
import * as types from "./actionTypes";

export function getHomePageData(clientId) {
  const url = `${URL.page}/home?clientId=${clientId}`;

  const request = getRequest(url);

  return {
    type: types.GET_HOME_PAGE_DATA,
    payload: request,
  };
}
